function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 16C3.6 16 0 12.4 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8C16 12.4 12.4 16 8 16Z",
  fill: "#002868"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.78 12.5H4.22C3.824 12.5 3.5 12.176 3.5 11.78V4.22C3.5 3.824 3.824 3.5 4.22 3.5H11.78C12.176 3.5 12.5 3.824 12.5 4.22V11.78C12.5 12.176 12.176 12.5 11.78 12.5Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.25624 11.594C5.23254 11.594 5.21334 11.5724 5.21334 11.5487V10.3394C5.21334 10.3157 5.19414 10.2941 5.17044 10.2941H4.74354C4.71954 10.2941 4.69824 10.2749 4.69824 10.2512V10.0175C4.69824 9.99377 4.71984 9.97217 4.74354 9.97217H6.05754C6.08124 9.97217 6.10284 9.99347 6.10284 10.0175V10.2512C6.10284 10.2749 6.08124 10.2941 6.05754 10.2941H5.63304C5.60934 10.2941 5.58774 10.3154 5.58774 10.3394V11.5487C5.58774 11.5724 5.56854 11.594 5.54484 11.594H5.25624Z",
  fill: "#002868"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.41459 10.0175C7.41459 9.99377 7.43379 9.97217 7.45749 9.97217H7.74369C7.76739 9.97217 7.78899 9.99347 7.78899 10.0175V10.8428C7.78899 11.3318 7.51239 11.6156 7.07349 11.6156C6.63699 11.6156 6.36279 11.3318 6.36279 10.8428V10.0175C6.36279 9.99377 6.38199 9.97217 6.40569 9.97217H6.69189C6.71559 9.97217 6.73719 9.99347 6.73719 10.0175V10.8545C6.73719 11.0954 6.86109 11.267 7.07589 11.267C7.29069 11.267 7.41459 11.0954 7.41459 10.8545V10.0175V10.0175Z",
  fill: "#002868"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M9.10343 10.5018C9.06533 10.5018 9.05333 10.4874 9.03893 10.4589C8.98883 10.3419 8.87903 10.2681 8.71223 10.2681C8.56193 10.2681 8.43563 10.3206 8.43563 10.4208C8.43563 10.5306 8.55263 10.5759 8.81003 10.6068C9.20123 10.6521 9.42533 10.7715 9.42533 11.0814C9.42533 11.4297 9.11993 11.6133 8.72903 11.6133C8.39033 11.6133 8.09933 11.4486 8.05403 11.103C8.04923 11.0697 8.06603 11.0577 8.09933 11.0577H8.36183C8.39513 11.0577 8.41433 11.0721 8.42393 11.0982C8.45963 11.2128 8.58143 11.301 8.75783 11.301C8.91293 11.301 9.04883 11.2437 9.04883 11.1222C9.04883 10.9767 8.90573 10.9506 8.61953 10.9146C8.29043 10.8717 8.06153 10.7763 8.06153 10.4733C8.06153 10.1703 8.32163 9.95337 8.72933 9.95337C9.09653 9.95337 9.35183 10.1514 9.40433 10.4472C9.41153 10.4805 9.40193 10.5021 9.36623 10.5021H9.10343V10.5018Z",
  fill: "#002868"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M9.74944 11.594C9.72574 11.594 9.70654 11.5724 9.70654 11.5487V10.0175C9.70654 9.99377 9.72574 9.97217 9.74944 9.97217H10.398C10.8798 9.97217 11.2542 10.3037 11.2542 10.7879C11.2542 11.2649 10.8846 11.594 10.398 11.594H9.74944ZM10.398 11.2718C10.6581 11.2718 10.8606 11.0666 10.8606 10.7828C10.8606 10.499 10.6578 10.2938 10.3956 10.2938H10.1262C10.1025 10.2938 10.0833 10.3151 10.0833 10.3391V11.2286C10.0833 11.2523 10.1025 11.2715 10.1262 11.2715H10.398V11.2718Z",
  fill: "#002868"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2601 9.08011H3.74012C3.67412 9.08011 3.62012 9.02611 3.62012 8.96011V4.22012C3.62012 3.89012 3.89012 3.62012 4.22012 3.62012H11.7801C12.1101 3.62012 12.3801 3.89012 12.3801 4.22012V8.96011C12.3801 9.02611 12.3261 9.08011 12.2601 9.08011Z",
  fill: "#002868"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M8.44129 8.10671H7.66129C7.61179 8.10671 7.57129 8.06621 7.57129 8.01671V4.71671C7.57129 4.66721 7.61179 4.62671 7.66129 4.62671H8.44129C8.49079 4.62671 8.53129 4.66721 8.53129 4.71671V8.01671C8.53129 8.06621 8.49079 8.10671 8.44129 8.10671Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M9.76965 5.58671H6.22965C6.18015 5.58671 6.13965 5.54621 6.13965 5.49671V4.71671C6.13965 4.66721 6.18015 4.62671 6.22965 4.62671H9.76965C9.81915 4.62671 9.85965 4.66721 9.85965 4.71671V5.49671C9.85965 5.54621 9.81915 5.58671 9.76965 5.58671Z",
  fill: "white"
});

var SvgTusd = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTusd, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tusd.cd9a19d2.svg";
export { ForwardRef as ReactComponent };